import React from "react";
import { useSelector } from "react-redux";

import { FaUsers } from "react-icons/fa";

import { SelectedEventsContainer } from "../../../common/styled/project";
import { getEventColor, timeByDate } from "../../../../../scheduler/component/function/common";
import moment from "moment";

const SelectedEvents = ({ selectEvent, setSelectEvent, selection, handleEventClick }) => {
  return selectEvent && selectEvent.length > 0 ? (
    <SelectedEventsContainer>
      <div className="bg" onClick={() => setSelectEvent([])}></div>
      <div className="contents">
        <div className="date">{moment(selection).format("YYYY년 M월 D일")}</div>
        <ul>
          {selectEvent.map((event) => (
            <li onClick={() => handleEventClick(event, true)}>
              {event.createDt !== event.updateDt && <span className="tag">수정</span>}
              <p>
                {event.certainType && <span>({event.certainType}) </span>}
                <span>{event.title}</span>
              </p>
              <p>{timeByDate(selection, event.startDt, event.endDt)}</p>
              {event.workerList && (
                <>
                  <i>
                    <FaUsers />
                  </i>
                  <div className="worker">
                    {Object.entries(event.workerList ?? {}).map(([key, worker], i, arr) => (
                      <span key={key}>
                        {worker}
                        {i < arr.length - 1 && ", "}
                      </span>
                    ))}
                  </div>
                </>
              )}
            </li>
          ))}
        </ul>
      </div>
    </SelectedEventsContainer>
  ) : null;
};

export default SelectedEvents;
